
function updateMountyardVariantLinks(card, variantId) {
  if (!variantId) return;

  // Update both the product image link and the product title link.
  card.querySelectorAll(
    '.mountyard-card-image-link, .card__heading a'
  ).forEach(function (link) {
    const href = link.getAttribute('href');
    if (!href) return;

    const url = new URL(href, window.location.origin);
    url.searchParams.set('variant', variantId);

    link.setAttribute('href', url.pathname + url.search + url.hash);
  });

  // Update the quick-add button.
  const quickAddButton = card.querySelector(
    '.quick-add__submit[data-product-url]'
  );

  if (quickAddButton) {
    const productUrl = new URL(
      quickAddButton.getAttribute('data-product-url'),
      window.location.origin
    );

    productUrl.searchParams.set('variant', variantId);

    quickAddButton.setAttribute(
      'data-product-url',
      productUrl.pathname + productUrl.search + productUrl.hash
    );
  }
}

document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.mountyard-card-swatch');
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest('.product-card-wrapper');
  if (!card) return;

  const imageUrl = swatch.dataset.variantImage || '';
  const variantId = swatch.dataset.variantId || '';

  // Change the collection card image.
  if (imageUrl) {
    const productImage = card.querySelector(
      '.card__media .media > img:first-child'
    );

    if (productImage) {
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('sizes');
      productImage.src = imageUrl;
    }
  }

  // Update the active color swatch.
  card.querySelectorAll('.mountyard-card-swatch').forEach(function (button) {
    const active = button === swatch;

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  // Update image link, title link, and quick-add together.
  updateMountyardVariantLinks(card, variantId);
});

function initializeMountyardCards() {
  document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
    const activeSwatch = card.querySelector(
      '.mountyard-card-swatch.is-active'
    );

    if (!activeSwatch) return;

    activeSwatch.setAttribute('aria-pressed', 'true');

    updateMountyardVariantLinks(
      card,
      activeSwatch.dataset.variantId || ''
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMountyardCards);
} else {
  initializeMountyardCards();
}
